import { Api } from '../api';

const api = new Api({
  initialData: null,
  namespace: 'USER',
  throwable: true,
  url: '/auth/me',
});

export const fetchCurrentUser = () => api.fetch();

export const reducer = api.reducer;
